import { registerBrick, Config, BrickContext } from 'olympe';
import { ReactBrick, useProperty } from '@olympeio/core';
import React from 'react';
import { GridRenderCellParams } from '@mui/x-data-grid';
import { DataGridPro, LicenseInfo, GridToolbar } from '@mui/x-data-grid-pro';
import { ThemeProvider } from '@mui/material/styles';
import { UserAvatar } from '../shared/UserAvatar.jsx';
import Tooltip from '@mui/material/Tooltip';
import { datagridTheme } from '../shared/_theme.jsx';

export default class ApproversChangedBrick extends ReactBrick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @returns {function(object): React.ReactElement}
     */
    static getReactComponent($) {
        return (props) => {
            // listen to properties
            const loading = useProperty($, 'Loading');
            let data = useProperty($, 'Data') || [];
            const sortBy = useProperty($, 'Sort By');

            console.log('ApproversChangedData', data);

            // setup data grid, columns to display
            const licenseKey = Config.getParameter('uiappValues.datagrid_license');
            LicenseInfo.setLicenseKey(licenseKey);

            /**
             * @param {GridRenderCellParams} params
             * @returns {React.ReactNode}
             */
            const approverCellRenderer = (params) => {
                const username = params.value || '';
                return (
                    <div className={'user-list'}>
                        {username && (
                            // <Tooltip title={username} placement={'top'} arrow>
                            //     <UserAvatar username={username} marginright={0} />
                            // </Tooltip>
                            <Tooltip
                                title={<div style={{ whiteSpace: 'pre-line' }}>{username.replaceAll(';', '\n')}</div>}
                                placement={'top'}
                                arrow
                            >
                                <div style={{ display: 'flex' }}>
                                    {username.split(';').map((user) => (
                                        <UserAvatar username={user} margin={'no'} key={user} />
                                    ))}
                                </div>
                            </Tooltip>
                        )}
                    </div>
                );
            };

            /**
             *
             * @param {string} id1
             * @param {string} id2
             * @returns {number}
             */
            const costObjectSortComparator = (id1, id2) => {
                return Number.parseInt(id1) - Number.parseInt(id2);
            };

            const columns = [];
            const defineColumn = (field, headerName, otherProps) => {
                const col = {
                    field,
                    headerName,
                    resizable: false,
                    disableColumnMenu: true,
                    sortable: true,
                    filterable: true,
                    hideable: true,
                    pinnable: false,
                    ...otherProps,
                };

                if (field === 'ConfigAppr' || field === 'WfAppr') {
                    col.sortable = false;
                }

                columns.push(col);
                return col;
            };

            defineColumn('DocNo', 'Purchasing Document', { width: 120, filterable: true, disableColumnMenu: false });
            defineColumn('DocItem', 'Item', { width: 75, filterable: true, disableColumnMenu: false });
            defineColumn('Bukrs', 'Comp. Code', { width: 70 });
            defineColumn('DocType', 'Doc. Categ.', { flex: 1 });
            defineColumn('ProcCreDate', 'Processing Date', { width: 110 });
            defineColumn('DocDate', 'Document Date', { width: 110 });
            defineColumn('Ekorg', 'Purch. Org.', { width: 70 });
            defineColumn('Ekgrp', 'Purch. Group', { width: 70 });
            defineColumn('CostObject', 'Cost Object', {
                width: 120,
                cellClassName: 'MuiDataGrid-cellBold',
                sortComparator: costObjectSortComparator,
            });
            defineColumn('CostObjectType', 'Cost Object Type', {
                width: 110,
                sortComparator: costObjectSortComparator,
            });
            defineColumn('Frggr', 'Rel. Group', { width: 65 });
            defineColumn('Frgco', 'Rel. Code', { width: 65 });
            defineColumn('ConfigAppr', 'Current Approvers in Config', {
                flex: 1,
                filterable: false,
                sortable: false,
                renderCell: approverCellRenderer,
            });
            defineColumn('WfAppr', 'Previous Workflow Approvers', {
                flex: 1,
                filterable: false,
                sortable: false,
                renderCell: approverCellRenderer,
            });
            defineColumn('WiId', 'Workflow ID', { width: 150 });

            // check if a column should be used for sorting
            let sortModel;
            const asc = true;
            if (sortBy && columns.some((c) => c.field === sortBy)) {
                sortModel = [{ field: sortBy, sort: asc ? 'asc' : 'desc' }];
            } else {
                sortModel = undefined;
            }

            // process data, add unique index prop
            if (!loading) {
                data.forEach((o, i) => {
                    o.id = i;
                });
            } else {
                data = [];
            }

            // render
            return (
                <ThemeProvider theme={datagridTheme}>
                    <DataGridPro
                        columns={columns}
                        rows={data}
                        loading={loading}
                        sortModel={sortModel}
                        editMode="row"
                        components={{ Toolbar: GridToolbar }}
                        componentsProps={{
                            toolbar: { style: { height: '40px' } }, // give enough room for the filter pad number to display entirely
                        }}
                        sx={{
                            '& .MuiDataGrid-columnHeaderTitle': {
                                textOverflow: 'clip',
                                whiteSpace: 'break-spaces',
                                lineHeight: 1,
                            },
                        }}
                        scrollbarSize={17}
                    />
                </ThemeProvider>
            );
        };
    }
}

registerBrick('018999809eef3c950d36', ApproversChangedBrick);
